import { Component, HostListener, ViewChild, OnInit } from '@angular/core'
import { NgClass } from '@angular/common';
import { FormsModule, NgForm, NgModel } from '@angular/forms'
import { ResponsiveComponent, FilterPipe, HighlightDirective } from '../../../index'
import { LongtailService } from '@nx-superprep/backend/firebase'

@Component({
  selector: 'nx-superprep-searchbar',
  standalone: true,
  imports: [NgClass, FormsModule, HighlightDirective, FilterPipe],
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss'],
  queries: {
    "searchForm": new ViewChild( "searchForm" ),
    "searchText": new ViewChild( "searchText" ),
  },
})
export class SearchbarComponent extends ResponsiveComponent implements OnInit {
  mouseInFilter = false

  @HostListener('window:click', ['$event']) onClick(): void {
    if (!this.mouseInFilter) {
      this.collapsed = true
    }
  }

  onMouseOutFilter() {
    this.mouseInFilter = false
  }

  onMouseEnterFilter() {
    this.mouseInFilter = true
  }

  @ViewChild("inputField") inputField!:  { nativeElement: { focus: () => void } }

  toggleInput() {
    this.collapsed = !this.collapsed
    if (!this.collapsed) {
      this.searchText?.reset()
      this.inputField.nativeElement.focus()
      this.mouseInFilter = true
    }
   }

  public searchForm!: NgForm
  public searchText!: NgModel

  iconsearch = { src: '/assets/icons/akariconssearch.svg', alt: 'iconsearch' }

  get placeholder() { return this.search.placeholder ?? 'Search' }
  get keywords() { return this.search.keywords ?? [] }

  isSelected(keyword: string) {
    return this.search.selected === keyword
  }

  onSelect(keyword?: string) {
    this.toggleInput()
    this.search = {...this.search, selected: keyword }
    this.searchChange.emit(this.search)
    if (keyword) { this.searchService.logSearch(keyword) }
  }

  reset() {
    this.collapsed = false
    this.searchForm?.reset()
    this.searchText?.reset()
    this.search.selected = undefined
  }

  override ngOnInit(): void {
    super.ngOnInit()
    this.collapsed = true
  }

  constructor(
    private searchService: LongtailService,
  ) {
    super()
    super.rootClassName = 'searchbar-root-class-name'
  }
}
